import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import { IPagination } from 'app/types/common';
import { AddressesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createAddress = (data): any => action(types.CREATE_ADDRESS_REQUESTED, data);

export const updateAddress = (data): any => action(types.UPDATE_ADDRESS_REQUESTED, data);

export const deleteAddress = (addressId): any => action(types.UPDATE_ADDRESS_REQUESTED, addressId);

export const getAddress = (addressId): any => action(types.GET_ADDRESS_REQUESTED, addressId);

export const getAllAddresses = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ADDRESSES_REQUESTED, { pagination, compile });

export const selectAddress = (addressId): any => action(types.SELECT_ADDRESS_REQUESTED, {
  currentAddressId: addressId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createAddressPending: (payload): any => action(types.CREATE_ADDRESS_PENDING, payload),
  createAddressSuccess: (response): any => action(types.CREATE_ADDRESS_SUCCESS, {
    addressesById: response.entities.addresses,
    currentAddressId: response.result,
  }),
  updateAddressPending: (payload): any => action(types.UPDATE_ADDRESS_PENDING, payload),
  updateAddressSuccess: (response): any => action(types.UPDATE_ADDRESS_SUCCESS, {
    addressesById: response.entities.addresses,
    currentAddressId: response.result,
  }),
  updateAddressFailed: (error): any => action(types.UPDATE_ADDRESS_FAIL, { backendErrors: error }),
  deleteAddressPending: (): any => action(types.UPDATE_ADDRESS_PENDING, {}),
  deleteAddressSuccess: (response, userId): any => {
    localStorage.set(userId, { currentAddressId: null });

    return action(types.DELETE_ADDRESS_SUCCESS, {
      currentAddressId: response,
    });
  },
  getAddressPending: (): any => action(types.GET_ADDRESS_PENDING, {}),
  getAddressSuccess: (response): any => action(types.GET_ADDRESS_SUCCESS, {
    addressesById: response.entities.addresses,
    currentAddressId: response.result,
  }),
  getAddressFailed: (error): any => action(types.GET_ADDRESS_FAIL, { backendErrors: error }),
  deleteAddressFailed: (error): any => action(types.UPDATE_ADDRESS_FAIL, { backendErrors: error }),
  getAllAddressesPending: (pagination): any => action(types.GET_ALL_ADDRESSES_PENDING, { pagination }),
  getAllAddressesSuccess: (response, meta): any => action(types.GET_ALL_ADDRESSES_SUCCESS, {
    addressesById: response.entities.addresses,
    addressIds: response.result,
    meta,
  }),
  getAllAddressesFailed: (error): any => action(types.GET_ALL_ADDRESSES_FAIL, { backendErrors: error }),
  createAddressFailed: (error): any => action(types.CREATE_ADDRESS_FAIL, { backendErrors: error }),
};

export default null;
